import { render, staticRenderFns } from "./WangEditor5.vue?vue&type=template&id=939e609a"
import script from "./WangEditor5.vue?vue&type=script&lang=js"
export * from "./WangEditor5.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/componenterpserver/gitrepo/unitmodeler/jp-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('939e609a')) {
      api.createRecord('939e609a', component.options)
    } else {
      api.reload('939e609a', component.options)
    }
    module.hot.accept("./WangEditor5.vue?vue&type=template&id=939e609a", function () {
      api.rerender('939e609a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/editor/WangEditor5.vue"
export default component.exports